import React, {memo} from "react";
import SwiperCore, {Scrollbar, A11y} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';

import {useSelector} from "react-redux";
import {ICONS_PUBLIC_URL_SERVER, PUBLIC_URL_SERVER} from "../../../../../../apis";
import {LazyLoadImage} from "react-lazy-load-image-component";
import imgPlayS from "../../../../../../images/base-image-product.jpg"
import {useRouteMatch} from "react-router-dom";

// install Swiper components
SwiperCore.use([Scrollbar, A11y]);

const Categories = () => {
    const match = useRouteMatch();
    const store = useSelector(state => state.stores.list_stores.find(storeItem => storeItem.id === match.params.store));
    const {list_stores} = useSelector(state => state.stores);
    return (
        <div className={'box-list-swiper-categories'} dir={'ltr'}>
            <Swiper className={'cm-category-products-list-swiper'}
                    spaceBetween={0}
                    slidesPerView={'auto'}
            >
                {(typeof list_stores !== "undefined" && store) && list_stores.map(category => {
                    return (store.id === category.id) && (
                        <SwiperSlide key={category.id} className={'cm-swiper-slide-category-product'}>
                            <div className="item-category-product">
                                <div className={'box-img-item-category-product'}>
                                    <LazyLoadImage
                                        alt={category.title}
                                        src={PUBLIC_URL_SERVER + ICONS_PUBLIC_URL_SERVER + category.icon}
                                        placeholderSrc={imgPlayS}
                                    />
                                </div>
                                <div className="box-txt-item-category-title">
                                    <h6 className={'mt-1'}>{category.title}</h6>
                                    <h6 className={'mt-1'}>{category.sub_title}</h6>
                                    <h6 className={'mt-1'}>{category.first_delivery_time}</h6>
                                </div>
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
};

export default memo(Categories);
